import { render, staticRenderFns } from "./Homebottomright.vue?vue&type=template&id=29c3c15a&scoped=true"
import script from "./Homebottomright.vue?vue&type=script&lang=js"
export * from "./Homebottomright.vue?vue&type=script&lang=js"
import style0 from "./Homebottomright.vue?vue&type=style&index=0&id=29c3c15a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c3c15a",
  null
  
)

export default component.exports